export function getProductSerialNumber(){
  return window.sessionStorage.getItem('productSerialNumber') || ''
}
